import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { MasterApp } from './MasterApp';
import { GlobalStyle } from '../ui/GlobalStyle';
import { theme } from '../theme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <MasterApp />
    </ThemeProvider>
  </StrictMode>,
);
